export default __webpack_public_path__ + "static/media/TigerGlobal.45b38d98.svg";